import {CloseButton, createStyles, TextInput} from '@mantine/core';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    padding: '0 4px 8px 8px',
    borderBottom: `1px solid ${theme.colors.gray[4]}`,
    marginBottom: 8,
    flexShrink: 0,
  },
  searchInput: {
    flex: 1,
  },
  searchIcon: {
    fontSize: 12,
  },
}));

/** @package */
export interface SidebarSearchBarProps {
  query: string;
  onQueryChange: (query: string) => void;
  /** Optional content rendered to the right of the search input (e.g. a close sidebar button). */
  rightContent?: ReactNode;
}

/** @package */
export default function SidebarSearchBar({
  query,
  onQueryChange,
  rightContent,
}: SidebarSearchBarProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.wrapper} {...getTestProps({component: 'SidebarSearchBar', element: 'root'})}>
      <TextInput
        className={classes.searchInput}
        icon={<BenchlingIcon icon="search" className={classes.searchIcon} />}
        placeholder="Search"
        value={query}
        onChange={(e) => {
          onQueryChange(e.currentTarget.value);
        }}
        onKeyUp={(e) => {
          if (e.key === 'Escape') {
            onQueryChange('');
          }
        }}
        rightSection={
          query ? (
            <CloseButton
              size="sm"
              onClick={() => {
                onQueryChange('');
              }}
              aria-label="Clear search"
            />
          ) : undefined
        }
        size="xs"
        styles={{
          input: {
            // !important needed to override the global `#editor input` selector
            // which resets border-radius and padding on all inputs within the editor.
            borderRadius: '4px !important',
            paddingLeft: '22px !important',
          },
          icon: {
            width: 22,
            justifyContent: 'center',
          },
        }}
        {...getTestProps({component: 'SidebarSearchBar', element: 'input'})}
      />
      {rightContent}
    </div>
  );
}
